import randomIntInRange from "@/functional/randomIntInRange";

export default (min: number, max: number) => {
  /*
   * Returns a function that resolves to its input parameter after
   * waiting for a random number of seconds (bounded by min & max)
   **/
  return <T>(r: T): Promise<T> => {
    return new Promise((resolve) =>
      setTimeout(() => resolve(r), randomIntInRange(min, max)),
    );
  };
};
